export default "__VITE_ASSET__5vcdcHMB__"